import React from 'react';
import { providerAvailabilityList } from 'api/appointmentSetting';
import { IproviderAvailabilityList } from 'types/appointmentSetting';
import { getUserId } from 'utils/localstore';

let globalData: IproviderAvailabilityList = {};

export const initData: IproviderAvailabilityList = {
    providerId: 0,
    timezone: 'America/Los_Angeles',
    isInit: true,
    week: [
        {
            weekDay: 'sunday',
            hourFromTo: [
                {
                    fromHour: 9,
                    fromMinute: 0,
                    toHour: 17,
                    toMinute: 0,
                },
            ],
        },
        {
            weekDay: 'monday',
            hourFromTo: [
                {
                    fromHour: 9,
                    fromMinute: 0,
                    toHour: 17,
                    toMinute: 0,
                },
            ],
        },
        {
            weekDay: 'tuesday',
            hourFromTo: [
                {
                    fromHour: 9,
                    fromMinute: 0,
                    toHour: 17,
                    toMinute: 0,
                },
            ],
        },
        {
            weekDay: 'wednesday',
            hourFromTo: [
                {
                    fromHour: 9,
                    fromMinute: 0,
                    toHour: 17,
                    toMinute: 0,
                },
            ],
        },
        {
            weekDay: 'thursday',
            hourFromTo: [
                {
                    fromHour: 9,
                    fromMinute: 0,
                    toHour: 17,
                    toMinute: 0,
                },
            ],
        },
        {
            weekDay: 'friday',
            hourFromTo: [
                {
                    fromHour: 9,
                    fromMinute: 0,
                    toHour: 17,
                    toMinute: 0,
                },
            ],
        },
        {
            weekDay: 'saturday',
            hourFromTo: [
                {
                    fromHour: 9,
                    fromMinute: 0,
                    toHour: 17,
                    toMinute: 0,
                },
            ],
        },
    ],
};

const useAvailability = (
    providerId?: number,
    scheduleToken?: string,
): [IproviderAvailabilityList, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<IproviderAvailabilityList>(globalData);
    const fetchData = async () => {
        try {
            setLoading(true);
            const uid = providerId || getUserId();
            const result = await providerAvailabilityList(uid, scheduleToken);
            if (!result.error) {
                const data: IproviderAvailabilityList = result?.data?.data || initData;
                globalData = data;
                setItems(globalData);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        fetchData();
    }, []);

    return [items, loading, fetchData];
};

export default useAvailability;
